import { StrictMode } from 'react';
import * as Sentry from '@sentry/react';
import { OverlayProvider } from 'overlay-kit';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { RouterProvider } from 'react-router-dom';
import { ErrorPage } from '@/app/pages/error';
import { router } from '@/app/router';
import { initSentry } from '@/shared/lib/sentry';
import { QueryProvider } from '@/shared/providers/query-provider';
import { Toaster } from '@/shared/ui/toast';

import './app/globals.css';

// Sentry 초기화
initSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorPage />}>
      <HelmetProvider>
        <QueryProvider>
          <OverlayProvider>
            <RouterProvider router={router} />
            <Toaster position="top-right" />
          </OverlayProvider>
        </QueryProvider>
      </HelmetProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>
);
